/* ═══════════════════════════════════════════
   KADIMAN ESSENTIALS — THEME JS
   ═══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  /* ─── HEADER SCROLL ─── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ─── HERO PARALLAX ─── */
  const heroImg = document.getElementById('heroImg');
  if (heroImg) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      heroImg.style.transform = `translateY(${y * 0.35}px) scale(1.1)`;
    }, { passive: true });
  }

  /* ─── FULLSCREEN BREAK PARALLAX ─── */
  const breakEl  = document.getElementById('fullscreen-break');
  const breakImg = document.getElementById('breakImg');
  if (breakEl && breakImg) {
    window.addEventListener('scroll', () => {
      const rect     = breakEl.getBoundingClientRect();
      const progress = -rect.top / window.innerHeight;
      breakImg.style.transform = `translateY(${progress * 60}px)`;
    }, { passive: true });
  }

  /* ─── STATEMENT WORD REVEAL ─── */
  const stmtText = document.getElementById('stmtText');
  if (stmtText && stmtText.dataset.text) {
    const phrase = stmtText.dataset.text;
    stmtText.innerHTML = '';
    phrase.split(' ').forEach((w, i) => {
      const span = document.createElement('span');
      span.className = 'word' + (i % 7 === 3 ? ' italic' : '');
      span.textContent = w;
      span.style.transitionDelay = `${i * 0.05}s`;
      stmtText.appendChild(span);
    });
  }

  /* ─── INTERSECTION OBSERVER ─── */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.classList.add('visible');

      if (e.target.id === 'stmtText') {
        e.target.querySelectorAll('.word').forEach((w, i) => {
          setTimeout(() => w.classList.add('visible'), i * 55);
        });
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll(
    '.reveal, .stat, .perk, .prod-card, #stmtLabel, #stmtText, .break-text, .stagger, #about'
  ).forEach(el => io.observe(el));

});
